import { Component, Input, forwardRef, OnInit, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true
    }
  ]
})
export class SelectComponent implements ControlValueAccessor, OnInit {
  @Input() label: string = '';
  @Input() fControlName: string = '';
  @Input() isFormControl: boolean = false;
  @Input() placeholder: string = '';
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() prefixIcon: string = '';
  @Input() suffixIcon: string = '';
  @Input() errorMessage: string = '';
  @Input() formControl!: FormControl;
  @Input() formGroup!: any;
  @Input() appearance: 'fill' | 'outline' = 'outline';
  @Input() floatLabel: 'always' | 'auto' = 'auto';
  @Input() noMargin: boolean = false;
  @Input() options: {key: string, value: string, icon?: string}[] = [];

  @Output() selectionChange = new EventEmitter<any>();

  value: any = '';
  isDisabled: boolean = false;

  // ControlValueAccessor methods
  onChange = (value: any) => {};
  onTouched = () => {};

  ngOnInit() {
    if (this.disabled) {
      this.isDisabled = true;
    }
  }

  onSelectionChange(event: any) {
    this.value = event;
    this.onChange(event);
    this.selectionChange.emit(event);
  }

  onInput(event: any) {
    const value = event.target.value;
    this.value = value;
    this.onChange(value);
  }

  onBlur() {
    this.onTouched();
  }

  // ControlValueAccessor implementation
  writeValue(value: any): void {
    this.value = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  get theFormControl(): FormControl {
    return this.formControl || this.formGroup.get(this.fControlName) as FormControl;
  }
  // Validation helpers
  get hasError(): boolean {
    return !this.theFormControl?.valid && (this.theFormControl?.dirty || this.theFormControl?.touched);
  }

  get errorMessages(): string[] {
    const errors: string[] = [];
    if (this.theFormControl?.errors) {
      if (this.theFormControl.errors['required']) {
        errors.push(`${this.label || 'This field'} is required`);
      }
      if (this.theFormControl.errors['email']) {
        errors.push('Please enter a valid email address');
      }
      if (this.theFormControl.errors['minlength']) {
        errors.push(`Minimum length is ${this.theFormControl.errors['minlength'].requiredLength} characters`);
      }
      if (this.theFormControl.errors['maxlength']) {
          errors.push(`Maximum length is ${this.theFormControl.errors['maxlength'].requiredLength} characters`);
      }
      if (this.theFormControl.errors['pattern']) {
        errors.push('Please enter a valid format');
      }
    }
    if (this.errorMessage) {
      errors.push(this.errorMessage);
    }
    return errors;
  }
}
